import api, { API_URL } from '@/utils/api';
import { toast } from 'sonner';


/**
 * Download a file from a GET endpoint by opening it in a new tab.
 * Works in sandboxed iframes because allow-popups is set.
 */
export function downloadViaGet(path) {
  const token = localStorage.getItem('access_token');
  const url = `${API_URL}${path}${path.includes('?') ? '&' : '?'}token=${encodeURIComponent(token)}`;
  window.open(url, '_blank');
}

/**
 * Triggers a download from a Blob using the most reliable method available.
 * Handles iframe sandbox restrictions, popup blockers, etc.
 */
export function triggerBlobDownload(blob, filename) {
  const blobUrl = URL.createObjectURL(blob);

  // Method: anchor click with DOM attachment (most reliable)
  const link = document.createElement('a');
  link.style.display = 'none';
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();

  // Cleanup after a delay to ensure download starts
  setTimeout(() => {
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  }, 1000);
}

/**
 * Download a file from a POST endpoint.
 * Sends JSON body, receives binary response, triggers download.
 */
export async function downloadViaPost(path, body, filename) {
  try {
    const response = await api.post(path, body, { responseType: 'blob' });
    const contentType = response.headers['content-type'] || 'application/octet-stream';
    const blob = new Blob([response.data], { type: contentType });
    triggerBlobDownload(blob, filename);
    return true;
  } catch (error) {
    console.error('Download failed:', error);
    toast.error('Failed to download file');
    return false;
  }
}
